import * as angular from 'angular';
import ProcedureBulkImportModalBridge from './ProcedureBulkImportModalBridge';

angular
  .module('flowingly.runner.library')
  .component('procedureBulkImportModal', ProcedureBulkImportModalBridge);
